import { render, staticRenderFns } from "./MenuDialog.vue?vue&type=template&id=61f6536a"
import script from "./MenuDialog.vue?vue&type=script&lang=js"
export * from "./MenuDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports